import type { FlagValue } from '@anchorage/feature-flags';
import { TextArea } from '@latitude/text-area';
import React from 'react';

import { FlagActions } from './FlagActions';

type ObjectFlagInputProps = {
  flagKey: string;
  displayValue: FlagValue;
  isOverridden: boolean;
  defaultValue: FlagValue | undefined;
  hasUnsavedChanges: boolean;
  onChange: (key: string, value: FlagValue) => void;
  onReset: (key: string) => void;
  onSave: (key: string) => void;
};

export const ObjectFlagInput: React.FC<ObjectFlagInputProps> = ({
  flagKey,
  displayValue,
  isOverridden,
  defaultValue,
  hasUnsavedChanges,
  onChange,
  onReset,
  onSave,
}) => {
  // For objects, we need to serialize to a formatted JSON string for display
  const objectDisplayValue =
    typeof displayValue === 'string'
      ? displayValue
      : JSON.stringify(displayValue, null, 2);

  return (
    <div className="space-y-2">
      <TextArea
        value={objectDisplayValue}
        onChange={(event) => {
          // Store the raw string value while editing
          // It will be parsed to JSON when user clicks Save
          onChange(flagKey, event.target.value as FlagValue);
        }}
      />
      <FlagActions
        flagKey={flagKey}
        isOverridden={isOverridden}
        hasUnsavedChanges={hasUnsavedChanges}
        formattedDefaultValue={JSON.stringify(defaultValue)}
        onReset={onReset}
        onSave={onSave}
      />
    </div>
  );
};
